import { FC } from 'react';
import classnames from 'classnames';

interface Props {
  badges?: string[];
  className?: string;
}

/** Renders an offer's per-line badge pills (e.g. "2 FOR 1") on a cart/checkout line. */
const OrderLineBadges: FC<Props> = ({ badges, className }) => {
  if (!badges?.length) {
    return null;
  }

  return (
    <div className={classnames('flex flex-wrap gap-xs', className)}>
      {badges.map((badge) => (
        <span key={badge} className={badgeStyle}>
          {badge}
        </span>
      ))}
    </div>
  );
};

export default OrderLineBadges;

const badgeStyle =
  'w-fit bg-brand-primary/30 text-xs px-xs py-2xs rounded flex items-center justify-center text-brand-primary font-medium';
